import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import { IStandardSummary, IStandardSummaryDatabase, IStandardSummaryType } from '../../../common/sharedTypes';

import * as urls from '../../shared/urls';
// types
export enum StandardSummaryActionTypes {
  SEARCH = '@@standardSummarysadmin/SEARCH',
  GENERATE = '@@standardSummarysadmin/GENERATE',
  REGENERATE = '@@standardSummarysadmin/REGENERATE',
  SEND = '@@standardSummarysadmin/SEND',
  TYPES = '@@standardSummarysadmin/TYPES',
  DATABASES = '@@standardSummarysadmin/DATABASES'
}

export const standardSummarySearch = (url: string, params: any) => {
  return async (dispatch) => {
    try {
      Api.post(url, params).then((result: ApiResponse<any>) => {
        dispatch(reduceResults(result.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const reduceResults = (result: IStandardSummary[]) => {
  return {
    type: StandardSummaryActionTypes.SEARCH,
    value: result,
  };
};

export const getStandardSummaryTypes = (url: string) => {
  return async (dispatch) => {
    try {
      Api.get(url).then((result: ApiResponse<any>) => {
        dispatch(reduceStandardSummaryTypes(result.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const reduceStandardSummaryTypes = (result: IStandardSummaryType[]) => {
  return {
    type: StandardSummaryActionTypes.TYPES,
    value: result,
  };
};

export const getStandardSummaryDatabases = (url: string) => {
  return async (dispatch) => {
    try {
      Api.get(url).then((result: ApiResponse<any>) => {
        dispatch(reduceStandardSummaryDatabases(result.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const reduceStandardSummaryDatabases = (result: IStandardSummaryDatabase[]) => {
  return {
    type: StandardSummaryActionTypes.DATABASES,
    value: result,
  };
};

export const viewData = (standardSummaryId: number) => {
  return new Promise((resolve, reject) => {
    Api.get(`${urls.GET_STANDARD_SUMMARY}?standardSummaryId=${standardSummaryId}`)
      .then((response: ApiResponse<any>) => {
        if (response.data) {
          const standardSummary = response.data;
          const downloadLink = document.createElement('a');
          downloadLink.href = `data:application/pdf;base64,${standardSummary.data}`;
          downloadLink.download = `StandardSummary_${standardSummaryId}.pdf`;
          downloadLink.click();
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        resolve(null);
      });
  });
};
